// test1166
(1166 && 0);
